module.exports = __webpack_public_path__ + "static/img/baccarat_th.654d42f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/baccarat_th.png
// module id = b0/7
// module chunks = 1